import { render, staticRenderFns } from "./ContractTermEditor.yaml?vue&type=template&id=6b876902&component"
import script from "./ContractTermEditor.yaml?vue&type=script&lang=ts&component"
export * from "./ContractTermEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports